export const iconFontAwesomeEditingLink = (
	<i className="fa-solid fa-link"></i>
);
